import type { ListPagination as DepartmentListPagination } from "../Interfaces/DepartmentInterface";

export type ListPagination = DepartmentListPagination;

export interface CursorListPage<T> {
  items: T[];
  pagination?: ListPagination;
  /** @deprecated Legacy flat cursor — use pagination.nextCursor */
  nextCursor?: string | null;
}

/** Resolve the next cursor from a list page (supports nested pagination or legacy flat nextCursor). */
export function getNextCursorFromPage(page: CursorListPage<unknown>): string | undefined {
  if (page.pagination) {
    return page.pagination.hasMore && page.pagination.nextCursor
      ? page.pagination.nextCursor
      : undefined;
  }
  return page.nextCursor ?? undefined;
}

/** Fetch all pages from a cursor-paginated list endpoint. */
export async function fetchAllListPages<T>(
  fetchPage: (cursor?: string) => Promise<CursorListPage<T>>
): Promise<T[]> {
  const results: T[] = [];
  let cursor: string | undefined;

  do {
    const data = await fetchPage(cursor);
    results.push(...(data.items ?? []));
    cursor = getNextCursorFromPage(data);
  } while (cursor);

  return results;
}
